var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomizeViewSolid = function SvgCustomizeViewSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 1.732-1",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10c.63 0 1.855-.357 1.988-1.746H9c-2 0-2.5-.754-2.5-2.754v-2c0-2 .5-2.754 2.5-2.754h8V5a2 2 0 0 0-2-2Zm-2 3.5c.5 0 1 .5 1 1v1c0 .5-.5 1-1 1H7c-.5 0-1-.5-1-1v-1c0-.5.5-1 1-1h6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14c1 0 1 0 1 1v1c0 1 0 1-1 1h-6c-1 0-1 0-1-1v-1c0-1 0-1 1-1h6Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17v-3l2 1.5-2 1.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
};
export default SvgCustomizeViewSolid;